<template>
  <NuxtLink
    :to="service.link"
    class="dark:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.5)] overflow-hidden dark:hover:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.8)] dark:bg-transparent bg-white rounded-xl hover:[box-shadow:0_.0625rem_.75rem_0_rgba(38,57,82,.2)] [box-shadow:0_.3em_.3em_-.3em_hsla(0,0%,4%,.1),_0_0_0_.1rem_hsla(0,0%,4%,.08)] transition-all duration-200"
  >
    <div
      v-if="service.image"
      class="relative flex items-center justify-center"
      :class="headerClasses"
    >
      <NuxtImg
        :src="service.image"
        :alt="service.title"
        width="369"
        height="235"
        class="w-full"
        loading="lazy"
         format="webp"
      />
    </div>

    <div class="p-6">
      <div class="flex mb-3">
        <div class="shrink-0" v-if="service.icon">
          <NuxtImg
            :src="service.icon"
            :alt="service.title"
            width="32"
            height="32"
            class="mr-3"
            loading="lazy"
             format="webp"
          />
        </div>
        <div>
          <h3 class="font-bold text-[var(--primary)] text-lg leading-tight">
            {{ service.title }}
          </h3>
          <p class="leading-relaxed">{{ service.description }}</p>
        </div>
      </div>
    </div>
  </NuxtLink>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  service: {
    type: Object,
    required: true,
  },
});

const headerClasses = computed(() => {
  return props.service.image ? "" : "relative overflow-hidden";
});
</script>
